/* demesy-zero-price.js — Auto-hide price line for $0 products in Boost */
(function () {
  'use strict';

  var PRICE_WRAPPER = '.boost-sd__product-price-wrapper';
  var CARD_SELECTOR = '[data-product-id]';

  function isZeroPrice(wrapper) {
    var clone = wrapper.cloneNode(true);
    clone.querySelectorAll('s, del').forEach(function (el) { el.remove(); });
    var nums = clone.textContent.match(/\d[\d,]*\.?\d*/g);
    if (!nums || nums.length === 0) return true;
    return nums.every(function (n) { return parseFloat(n.replace(/,/g, '')) === 0; });
  }

  function processCard(card) {
    var wrapper = card.querySelector(PRICE_WRAPPER);
    if (!wrapper || !isZeroPrice(wrapper)) return;
    wrapper.style.display = 'none';
  }

  function scan(root) {
    (root || document).querySelectorAll(CARD_SELECTOR).forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(CARD_SELECTOR)) {
          processCard(node);
        } else {
          scan(node);
        }
      }
    }
  });

  function startObserver() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver);
  }
})();
